import { Icon } from '@vk-hr-tek/ui/Icon';
import { t } from '@vk-hr-tek/core/translations';

import { CustomLinksIcons } from '../../types';

export const FORM_ITEM_ICONS = () => [
  {
    value: CustomLinksIcons.globe,
    label: 'Стандартное',
    icon: (
      <Icon name="globe_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.document,
    label: 'Документ',
    icon: (
      <Icon name="document_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.bookmark,
    label: 'Флаг',
    icon: (
      <Icon name="bookmark_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.picture,
    label: 'Картинка',
    icon: (
      <Icon name="picture_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.cup,
    label: 'Кубок',
    icon: <Icon name="cup_outline" size="20" color="original.brand.primary" />,
  },
  {
    value: CustomLinksIcons.employee,
    label: t('settings.company.roleModel.sideEmployeeTitle'), // TODO: добавить отдельный ключ в переводы
    icon: <Icon name="user_outline" size="20" color="original.brand.primary" />,
  },
  {
    value: CustomLinksIcons.star,
    label: 'Звезда',
    icon: (
      <Icon name="favorite_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.flash,
    label: 'Молния',
    icon: (
      <Icon name="flash_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.hearts,
    label: 'Пара сердец',
    icon: (
      <Icon name="hearts_2_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.info,
    label: 'Информация',
    icon: (
      <Icon
        name="info_circle_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.notebook,
    label: 'Блокнот',
    icon: (
      <Icon
        name="notebook_check_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.video,
    label: 'Видео',
    icon: (
      <Icon
        name="video_square_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.employeeInfo,
    label: 'Записная книжка',
    icon: (
      <Icon
        name="vkhrtek_employee_info"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.card,
    label: 'Карточка',
    icon: (
      <Icon
        name="rectangle_info_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.hat,
    label: 'Академическая шапочка',
    icon: (
      <Icon name="education_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.lightbulb,
    label: 'Лампа',
    icon: (
      <Icon name="lightbulb_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.thermometer,
    label: 'Термометр',
    icon: (
      <Icon
        name="thermometer_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.chain,
    label: 'Цепь',
    icon: <Icon name="chain" size="20" color="original.brand.primary" />,
  },
  {
    value: CustomLinksIcons.phone,
    label: 'Трубка',
    icon: (
      <Icon name="phone_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.book,
    label: 'Книга',
    icon: (
      <Icon
        name="book_spread_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
  {
    value: CustomLinksIcons.building,
    label: 'Здание',
    icon: (
      <Icon name="building_outline" size="20" color="original.brand.primary" />
    ),
  },
  {
    value: CustomLinksIcons.grid,
    label: 'Плитки',
    icon: (
      <Icon
        name="grid_4_uneven_vertical_outline"
        size="20"
        color="original.brand.primary"
      />
    ),
  },
];
